import { useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { ConfirmDialogProps } from "components/ConfirmDialog";
import useAuth from "hooks/useAuth";
import { PlanStatus } from "models/plan";
import { useTranslation } from "react-i18next";
import { changePlanStatus, getPlans } from "services/planService";
import { queryClient } from "services/queryClient";

export const PLANS_QUERY_KEY = "plans";

export const useViewModel = () => {
  const navigate = useNavigate();
  const { selectedProvider, user } = useAuth();
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(1);
  const { data, isLoading, isError, refetch } = useQuery(
    [PLANS_QUERY_KEY, currentPage, selectedProvider.id],
    () =>
      getPlans(
        currentPage,
        20,
        selectedProvider.id === "admin" ? undefined : selectedProvider.id
      ),
    { enabled: user !== undefined && user.role !== "seller" }
  );

  const [confirmDialogData, setConfirmDialogData] =
    useState<ConfirmDialogProps>();

  async function handleChangeStatus(index: number, newStatus: PlanStatus) {
    const statusText = newStatus === "active" ? t("plans.status.active") : t("plans.status.inactive");
    setConfirmDialogData({
      show: true,
      title: "Alterar Status",
      message: `Deseja realmente alterar o status do plano para ${statusText}?`,
      onConfirm: async () => {
        toast.info("Atualizando status do plano...");
        try {
          setConfirmDialogData(undefined);
          await changePlanStatus(data!.data![index].id, newStatus);
          toast("Status atualizado com sucesso!", { type: "success" });
          queryClient.invalidateQueries([
            PLANS_QUERY_KEY,
            currentPage,
          ]);
        } catch (error) {
          toast("Erro ao atualizar status do plano", { type: "error" });
        }
      },
      onCancel: () => {
        setConfirmDialogData(undefined);
      },
    });
  }

  return {
    t,
    plans: data?.data,
    page: currentPage,
    nbPages: data?.pagination.nbPages,
    isLoading: isLoading,
    isError: isError,
    retry: refetch,
    confirmDialogData: confirmDialogData,
    setPage: setCurrentPage,
    handleChangeStatus: handleChangeStatus,
    navigate: navigate,
    user,
  };
}; 